import {JobStatus} from "../interfaces/JobStatus";
import {HttpService} from "./HttpService";

export class JobStatusUpdater {

    public jobUuid: string
    public updateInterval: number
    public language: string

    protected status: JobStatus|null = null
    private intervalTimer: number|null = null
    private readonly http: HttpService = HttpService.instance

    public constructor(jobUuid: string, updateInterval: number = 1000, language: string|null = null) {
        this.jobUuid = jobUuid
        this.updateInterval = updateInterval

        if (language) {
            this.language = language
        } else {
            this.language = document.documentElement.getAttribute('lang') || "en";
        }
    }

    public start(onChangeHandler: (status: JobStatus) => void, onDone: ((status: JobStatus) => void)|null = null) {
        this.intervalTimer = window.setInterval(() => {
            this.updateStatus(this.language, onChangeHandler, onDone)
        }, this.updateInterval)
    }

    public stop() {
        if (this.intervalTimer) {
            window.clearInterval(this.intervalTimer)
        }
    }

    public async updateStatus(lang: string, onChangeHandler: (status: JobStatus) => void, onDone: ((status: JobStatus) => void)|null) {
        try {
            this.status = await this.getStatus(lang)
            onChangeHandler(this.status)

            if (this.status.queue_status == 'finished' || this.status.queue_status == 'failed') {
                this.stop()
                if (onDone) {
                    onDone(this.status)
                }
            }
        } catch (e) {
            this.stop()
        }
    }

    public async getStatus(lang: string) {
        let url = `${APP_API_URL}jobqueue/${lang}/status/${this.jobUuid}`;
        let response = await this.http.get<JobStatus>(url);

        return response.body!
    }
}